import React from 'react';
import './OrderSummary.css';

const OrderSummary = ({ items, total, currency = 'EUR', selectedInstallments }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(amount / 100);
  };

  return (
    <div className="card shadow-sm mb-4 order-summary-mobile-margin">
      <div className="card-header bg-light">
        <h5 className="mb-0">Resumen del Pedido</h5>
      </div>
      <div className="card-body">
        <ul className="list-group list-group-flush mb-3">
          {items.map((item, index) => (
            <li key={index} className="list-group-item d-flex justify-content-between lh-sm">
              <div>
                <h6 className="my-0">{item.title}</h6>
                <small className="text-muted">Cantidad: {item.qty}</small>
              </div>
              <span className="text-muted">{formatCurrency(item.price * item.qty)}</span>
            </li>
          ))}
        </ul>
        
        {selectedInstallments && (
           <div className="alert alert-info py-2">
             <small>
               <strong>Financiación seleccionada:</strong> {selectedInstallments} cuotas
             </small>
           </div>
        )}

        <div className="d-flex justify-content-between border-top pt-3">
          <span className="h5">Total</span>
          <span className="h5">{formatCurrency(total)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
